import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUsers } from '@fortawesome/free-solid-svg-icons';

// Consent selector shared by the Create flow (before processing) and the
// result view (after processing): private vs. shared-for-review+fine-tuning.
const PrivacyChoice = ({ shared, onChange }) => {
    const choiceClasses = (active) =>
        `flex-1 max-w-sm text-left p-4 rounded-xl border-2 transition-all cursor-pointer ${
            active
                ? 'border-sil-yellow-500 bg-white bg-opacity-20 shadow-lg'
                : 'border-white border-opacity-30 bg-white bg-opacity-5 hover:bg-opacity-10'
        }`;

    return (
        <div className="flex flex-wrap justify-center gap-3 w-full">
            <button
                type="button"
                className={choiceClasses(!shared)}
                onClick={() => onChange(false)}
            >
                <div className="flex items-center gap-3 text-white font-bold text-lg">
                    <FontAwesomeIcon icon={faLock} />
                    Private
                </div>
                <p className="text-white text-opacity-80 text-sm mt-1">
                    Only you can see this video and its result.
                </p>
            </button>
            <button
                type="button"
                className={choiceClasses(!!shared)}
                onClick={() => onChange(true)}
            >
                <div className="flex items-center gap-3 text-white font-bold text-lg">
                    <FontAwesomeIcon icon={faUsers} />
                    Share for review
                </div>
                <p className="text-white text-opacity-80 text-sm mt-1">
                    Others may review and annotate this video, and I give
                    permission for it to be used to improve (fine-tune) the
                    model.
                </p>
            </button>
        </div>
    );
};

export default PrivacyChoice;
